import React from 'react';

const NotFoundContainer = () => <div>Not found</div>;

export default NotFoundContainer;
